<div class="flex flex-col gap-3">
  <form [formGroup]="form" class="space-y-6">
    <!-- Produto + Quantidade -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
      <div class="flex gap-2 col-span-2">
        <div class="w-full">
          <label class="block mb-1 font-medium md:col-span-3">Produto</label>
          <p-autoComplete
            #productAutoComplete
            [(ngModel)]="selectedProduct"
            [ngModelOptions]="{ standalone: true }"
            [suggestions]="filteredProducts"
            (completeMethod)="searchProducts($event)"
            field="description"
            (onSelect)="onProductSelect($event)"
            [minLength]="1"
            [forceSelection]="true"
            placeholder="Digite para buscar produto..."
            styleClass="w-full"
            inputStyleClass="w-full"
          />
        </div>
        <div class="flex items-end">
          <button
            (click)="changeModal()"
            class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
          >
            Pesquisar
          </button>
        </div>
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">Valor Unitário</label>
        <p-inputNumber
          currency="BRL"
          locale="pt-BR"
          mode="decimal"
          readonly
          formControlName="productValue"
          placeholder="0,00"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          class="w-full"
        />
      </div>

      <div class="flex gap-2">
        <div class="w-full">
          <label class="block mb-1 font-medium md:col-span-3">Quantidade</label>
         
          <p-inputNumber 
            #amountInput
            formControlName="amount" 
            mode="decimal" 
            [minFractionDigits]="2" 
            [maxFractionDigits]="2" 
            (onKeyDown)="onAmountKeyDown($event)"
            class="w-full">
        </p-inputNumber>
        </div>

        <div class="flex items-end">
          <button
            #addButton
            (click)="addItem()"
            class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
          >
            <i class="pi pi-plus mx-1"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Funcionário + Parcelas + Entrada + 1ª parcela + valores + data -->
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      <div>
        <label class="block mb-1 font-medium md:col-span-3">Funcionário</label>
        <p-select
          formControlName="employeeId"
          [options]="employeeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o funcionário"
          class="w-full"
          [filter]="true"
        ></p-select>
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">Parcelas</label>
        <p-select
          formControlName="installments"
          [options]="availableInstallments"
          (ngModelChange)="calculateInstallments($event)"
          class="w-full"
        ></p-select>
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">Valor de entrada</label>
        <p-inputNumber
          currency="BRL"
          locale="pt-BR"
          mode="decimal"
          formControlName="downPayment"
          placeholder="0,00"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [min]="0"
          class="w-full"
        />
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">Valor da 1ª parcela</label>
        <p-inputNumber
          currency="BRL"
          locale="pt-BR"
          mode="decimal"
          formControlName="firstInstallmentValue"
          placeholder="Opcional"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [min]="0"
          [disabled]="(form.get('installments')?.value ?? 1) === 1"
          class="w-full"
        />
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">{{ installmentValueLabel }}</label>
        <p-inputNumber
          currency="BRL"
          locale="pt-BR"
          mode="decimal"
          readonly
          [inputStyle]="{ width: '100%' }"
          formControlName="installmentValue"
          placeholder="0,00"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          class="w-full"
        />
      </div>

      <div>
        <label class="block mb-1 font-medium md:col-span-3">Valor Total</label>
        <p-inputNumber
          currency="BRL"
          locale="pt-BR"
          mode="decimal"
          [inputStyle]="{ width: '100%' }"
          formControlName="totalValue"
          placeholder="0,00"
          readonly
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          class="w-full"
        />
      </div>

      <div class="md:col-span-2 xl:col-span-2">
        <label class="block mb-1 font-medium">Data da primeira cobrança</label>
        <p-datepicker formControlName="initialInstallmentDate" class="w-full" />
      </div>
    </div>

    <!-- Tabela com rolagem -->
    <div class="px-6 py-4 bg-gray-50">
      <div class="bg-white shadow rounded md:max-h-50 lg:max-h-50 xs:max-h-80 overflow-y-auto">
        <table class="min-w-full text-sm table-fixed">
          <thead class="bg-gray-100 sticky top-0 z-10">
            <tr>
              <th class="text-left px-6 py-3">Produto</th>
              <th class="text-left px-6 py-3">Quantidade</th>
              <th class="text-left px-6 py-3">Valor</th>
              <th class="text-left px-6 py-3">Total</th>
              <th class="text-left px-6 py-3">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of order.items; let i = index"
              [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'"
            >
              <td class="px-6 py-2 font-mono">{{ item.productName }}</td>
              <td class="px-6 py-2 font-semibold text-gray-900">
                {{ item.amount }}
              </td>
              <td class="px-6 py-2 font-mono">{{ item.value | number: '1.2-2'}}</td>
              <td class="px-6 py-2 font-mono">{{ item.total | number: '1.2-2' }}</td>
              <td class="px-6 py-2">
                <div class="flex space-x-2">
                  <button
                    (click)="deleteItem(item)"
                    class="text-white cursor-pointer bg-orange-500 px-3 py-2 rounded hover:bg-orange-600"
                  >
                    <i class="pi pi-trash mx-1"></i>
                    <span class="ml-1">Excluir</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>

  <!-- Modal -->
  <app-modal [header]="'Seleção de Produtos'" [(visible)]="showModal" [focusOnShow]="false">
    <ng-container *ngIf="showModal">
      <app-select-product-to-order></app-select-product-to-order>
    </ng-container>
  </app-modal>
</div>